import axios from "axios";

export const getAllPostulationsByCourse = (course_id, callback) => {
  var promise = axios({
    method: "get",
    url: `/api/courses/${course_id}/postulation_bases`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const submitNextStage = (course_id, data, callback) => {
  var promise = axios({
    method: "post",
    url: `/api/courses/${course_id}/postulation_bases/next_stage`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const switchPostulationState = (
  course_id,
  postulation_id,
  data,
  callback
) => {
  var promise = axios({
    method: "patch",
    url: `/api/courses/${course_id}/postulation_bases/${postulation_id}/switch_state`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const sendUpdateRequestToApplicant = (data, callback) => {
  var promise = axios({
    method: "post",
    url: `/api/applicants/send_update_request`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const getAllApplicants = (courseId, callback) => {
  let url;
  if (courseId) {
    url = `/api/applicants/get_applicants?course_id=${courseId}`;
  } else {
    url = `/api/applicants/get_applicants`;
  }

  var promise = axios({
    method: "get",
    url: url,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const sendCourseInviteToApplicants = (data, callback) => {
  var promise = axios({
    method: "post",
    url: `/api/applicants/send_course_invitation`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const MasiveStateUpdatToApplicant = (data, callback) => {
  var promise = axios({
    method: "post",
    url: `/api/applicants/send_masive_update_postulation_state`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const moveApplicantsToNextStage = (courseId, postulationIds, stageType, forceNextStage, callback) => {
  var formData = new FormData();
  formData.append("course_id", courseId);
  formData.append("next_stage", stageType);
  formData.append("force_next_stage", forceNextStage ? "true" : "false"); // ✅ Corregido

  postulationIds.forEach(id => formData.append("postulation_ids[]", id));

  axios.post(`/api/courses/${courseId}/postulation_bases/send_masive_next_stage`, formData, {
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err.response));
};


export const getAllCourses = callback => {
  var promise = axios({
    method: "get",
    url: `/api/courses/get_courses`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const movePostulationsToCourse = (sourceCourseId, targetCourseId, postulationIds, callback) => {
  const formData = new FormData();
  formData.append("target_course_id", targetCourseId);
  (postulationIds || []).forEach(id => formData.append("postulation_ids[]", id));

  axios.post(`/api/courses/${sourceCourseId}/postulation_bases/move_to_course`, formData, {
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err?.response));
};


export const getCv = (applicant_id, callback) => {
  var promise = axios({
    method: "get",
    url: `/applicants/${applicant_id}/download_pdf`,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const submitSingleNextStage = (
  courseId,
  postulationId,
  data,
  callback
) => {
  var promise = axios({
    method: "post",
    url: `/api/courses/${courseId}/postulation_bases/${postulationId}/single_next_stage`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const updatePassword = (applicantId, data, callback) => {
  var promise = axios({
    method: "put",
    url: `/api/applicants/${applicantId}/update_password`,
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

export const createNewUser = (data, callback) => {
  axios({
    method: "post",
    url: `/api/users`,
    data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  })
    .then(response => callback(response))
    .catch(err => callback(err?.response));
};

export const sendPostulationsToHead = (courseId, postulationIds, callback) => {
  const formData = new FormData();
  postulationIds.forEach(id => formData.append("postulation_ids[]", id));
  axios.post(`/api/courses/${courseId}/postulation_bases/send_to_head`, formData, {
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(response => callback(response))
    .catch(err => callback(err.response));
};

export const createCourseSelections = (courseId, postulationIds, cb) => {
  const formData = new FormData();
  postulationIds.forEach(pid => formData.append("postulation_ids[]", pid));

  axios.post(`/api/courses/${courseId}/selections`, formData, {
    headers: { "X-CSRF-TOKEN": window.Hupe8.token }
  })
    .then(r => cb(r))
    .catch(e => cb(e.response));
};